<template>
  <div class="ai-visibility-source-summary">
    <source-avatar v-if="showAvatar" :domain="domain"/>
    <div class="ai-visibility-source-summary__copy">
      <span class="ai-visibility-source-summary__title">{{ title }}</span>
      <p v-if="subtitle">{{ subtitle }}</p>
    </div>
    <slot/>
  </div>
</template>

<script>
import SourceAvatar from './SourceAvatar.vue'

export default {
  name: 'SourceSummary',
  components: {
    SourceAvatar,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    domain: {
      type: String,
      required: true,
    },
    showAvatar: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-source-summary {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 12px;
}

.ai-visibility-source-summary__copy {
  min-width: 0;
  flex: 1 1 auto;
}

.ai-visibility-source-summary__title {
  display: block;
  overflow: hidden;
  color: var(--v-mainColor-base);
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 400;
}

.title-large {
  .ai-visibility-source-summary__title {
    font-size: 16px;
  }
}

.ai-visibility-source-summary p {
  overflow: hidden;
  color: var(--v-darkGrayColor-base);
  font-size: 14px;
  margin: 4px 0 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
